import { createAction } from 'redux-actions';
import loadScript from 'lib/loadScript';

const allowed = [
  'limit',
  'confighash',
  'returnmetadata',
];

const filtered = (raw) => Object.keys(raw)
  .filter((key) => allowed.includes(key))
  .reduce((obj, key) => ({ ...obj, [key]: raw[key] }), {});

export default function ({
  url, types, options, recType = '',
}) {
  return async (dispatch) => {
    const [PENDING, SUCCESS, ERROR] = types;
    const pending = createAction(PENDING);
    const success = createAction(SUCCESS);
    const error = createAction(ERROR);

    dispatch(pending());

    try {
      const attributes = {
        'data-publickey': 'a5d3c400d9872cc4aa3bb4e9c87c7cab',
        'data-onpluginload': '(function () { });',
      };

      const requestConfig = filtered(options);
      const vilynxScript = 'https://static.vilynx.com/vidrec/vidrec.3.3.3.min.js';

      // Load script
      await loadScript(vilynxScript, { location: 'body', attributes });

      // Load recommendations
      await window.vilynxRecommendations.get(
        url,
        (body) => {
          const { filter, map } = options.callbacks;
          dispatch(success({
            url,
            recType,
            data: body.filter(filter).map(map),
          }));
        },
        requestConfig,
      );
    } catch (e) {
      dispatch(error(e));
    }
  };
}
